import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderLogo from "../../assets/images/EconSignLogo.png";
import { 
  ArrowLeft, ArrowRight, Check, Globe, 
  Smartphone, Cpu, Plus, Send, ShieldCheck, Zap,
  Clock, Sparkles, Rocket
} from "lucide-react";
import "./GetEstimate.scss";

const GetEstimate = () => {
  const [step, setStep] = useState(1);
  const [service, setService] = useState("web");
  const [isDone, setIsDone] = useState(false);
  const navigate = useNavigate();

  const handleNext = () => setStep(step + 1);
  const handleBack = () => setStep(step - 1);

  if (isDone) {
    return (
      <div className="no-scroll-wrapper success-view">
        <div className="success-glass animate-pop">
          <div className="icon-circle">
            <Rocket size={50} className="rocket-anim" />
          </div>
          <h1>Mission Started!</h1>
          <p>We've received your brief. Our engineers are already brainstorming. Check your inbox soon.</p>
          <button onClick={() => navigate("/")} className="glow-btn">Return to Base</button>
        </div>
      </div>
    );
  }

  return (
    <div className="no-scroll-wrapper">
      <div className="bg-blobs">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      <header className="compact-header">
        <img src={HeaderLogo} alt="Logo" className="logo" onClick={() => navigate("/")} />
        <div className="step-pills">
          {[1, 2, 3].map(s => (
            <div key={s} className={`pill ${step === s ? 'active' : ''} ${step > s ? 'done' : ''}`}>
              {step > s ? <Check size={14} /> : s}
            </div>
          ))}
        </div>
      </header>

      <main className="main-viewport">
        <div className="content-container">
          
          {step === 1 && (
            <div className="view-step animate-in">
              <div className="title-area">
                <span className="mini-tag"><Zap size={14} /> Innovation Hub</span>
                <h2>What are we <span>Building?</span></h2>
              </div>
              
              <div className="grid-selection">
                {[
                  { id: 'web', icon: <Globe />, title: 'Web App' },
                  { id: 'mobile', icon: <Smartphone />, title: 'Mobile App' },
                  { id: 'software', icon: <Cpu />, title: 'Custom Tech' },
                  { id: 'others', icon: <Plus />, title: 'Special Brief' }
                ].map((item) => (
                  <div 
                    key={item.id} 
                    className={`glass-card ${service === item.id ? 'selected' : ''}`}
                    onClick={() => setService(item.id)}
                  >
                    <div className="card-icon">{item.icon}</div>
                    <h3>{item.title}</h3>
                  </div>
                ))}
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="view-step animate-in">
              <div className="title-area">
                <h2>Project <span>Timeline</span></h2>
                <p>How fast do you want to go live?</p>
              </div>
              
              <div className="timeline-options">
                {["1-2 Months", "3-6 Months", "6+ Months"].map(t => (
                  <label key={t} className="time-pill">
                    <input type="radio" name="timeline" />
                    <div className="pill-inner"><Clock size={16}/> {t}</div>
                  </label>
                ))}
              </div>

              <div className="text-box-area">
                <textarea placeholder="Quick summary of features..."></textarea>
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="view-step animate-in">
              <div className="title-area">
                <h2>Almost <span>There</span></h2>
                <p>We need a way to send your estimate.</p>
              </div>
              
              <div className="input-grid-compact">
                <div className="neon-input">
                  <input type="text" placeholder="Full Name" />
                </div>
                <div className="neon-input">
                  <input type="email" placeholder="Work Email" />
                </div>
                <div className="neon-input full-width">
                  <input type="text" placeholder="Company Name" />
                </div>
              </div>

              <div className="security-tag">
                <ShieldCheck size={16} /> Secure & Encrypted
              </div>
            </div>
          )}

        </div>
      </main>

      <footer className="compact-footer">
        <button className="btn-text" onClick={() => navigate("/")}>Cancel</button>
        <div className="nav-btns">
          {step > 1 && <button onClick={handleBack} className="btn-secondary">Back</button>}
          <button onClick={step < 3 ? handleNext : () => setIsDone(true)} className="btn-primary">
            {step < 3 ? "Continue" : "Get My Quote"} {step < 3 ? <ArrowRight size={18} /> : <Send size={18} />}
          </button>
        </div>
      </footer>
    </div>
  );
};

export default GetEstimate;